var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');

var OrganizationDataView = Marionette.View.extend({
    template: require('../../templates/organizations/organization-data.html'),

    ui: {
    	show: '#run-report',
    	reportType: '#reportType',        
        dateFrom: '#date-from',
        dateTo: '#date-to',
        basicTitleDates: '#basic-dates',
        referralTitleDates: '#referral-dates'       
    },
    
    events: {
        'click @ui.show': 'runReport',
        'change @ui.reportType': 'changeReportType'
    },
    
    modelEvents: {
        'change': 'fieldsChanged'
    },

    templateContext: function () {
        var that = this;
        var object = that.model.get('object');
        object.externalIds = object.externalIds || [];
        return {
            formattedDateTime: function (long) {
                return that.utils.longToDateTimeFormatted(long, 'MMM DD YYYY hh:mm A');
            },            
            dateFrom:null,
            dateTo:null,
            selectedReport:"",
            canEdit: that.canEdit,
            byAdmin: that.byAdmin,
            username: that.options.user.login,
            isMd: that.options.user.isMd,
            isOfficeAdministrator: that.options.user.isOfficeAdministrator,
            isMedicalDirector: that.options.user.isMedicalDirector,
            isManager: that.options.user.isManager,
            isAdmin: that.options.user.isAdmin,
            tels: that.utils.extractContactValuesByTypeAsString(object.contacts || [], 'PHONE'),
            faxes: that.utils.extractContactValuesByTypeAsString(object.contacts || [], 'FAX'),
            emails: that.utils.extractContactValuesByTypeAsString(object.contacts || [], 'EMAIL'),
            signedDocumentsLink: '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
            + '&ORGANIZATION_REVIEW_REQUEST=' + that.model.get('id') + '&ORGANIZATION_REVIEW_FINISHED_REQUEST=' + that.model.get('id')
            + '&object_status=SIGNED&object_status=VIEWED',
            pendingDocumentsLink: '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
            + '&ORGANIZATION_REVIEW_REQUEST=' + that.model.get('id') + '&NOT_ORGANIZATION_REVIEW_FINISHED_REQUEST=' + that.model.get('id')
            + '&object_status=IN_REVIEW',
            allDocumentsLink: '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
            + '&ORGANIZATION_REVIEW_REQUEST=' + that.model.get('id'),
            getMedsideExternalIdsParams: function () {
                if (object.externalIds.length == 0) {
                    return '';
                }
                return "org=" + object.externalIds.filter(function (id) {
                    return id.toLowerCase().startsWith('medside_');
                }).map(function (id) {
                    return id.toLowerCase().replace('medside_', '');
                }).join('&org=');
            }
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'fieldsChanged');
        this.utils = new CommonUtils();
        this.canEdit = options.canEdit;
        this.byAdmin = options.byAdmin;
    },

    fieldsChanged: function () {
        this.render();
    },
    
    getMedsideExternalIdsParams: function () {
    	var that = this;
    	var object = that.model.get('object');
        if (object.externalIds.length == 0) {
            return '';
        }
        return "org=" + object.externalIds.filter(function (id) {
            return id.toLowerCase().startsWith('medside_');
        }).map(function (id) {
            return id.toLowerCase().replace('medside_', '');
        }).join('&org=');
    },
    
    runReport: function () {
    	var  url = null;
    	var from = this.ui.dateFrom.val()?'from='+this.utils.dateToLong(this.ui.dateFrom.val())+'&':"";
    	var to = this.ui.dateTo.val()?'to='+(this.utils.dateToLong(this.ui.dateTo.val())+86340000)+'&':"";
    	switch(this.ui.reportType.val()){
    		case 'basic': url = '/#organization/'+this.model.get('id')+'/patients?'+from+to+this.getMedsideExternalIdsParams()+'&sourceOrganization=b2c93b43-c6ff-4ca0-b61d-88b2326bdcc0'; break;
    		case 'simple': url = '/#organization/'+this.model.get('id')+'/patients?'+from+to+'isSimple=true&'+this.getMedsideExternalIdsParams()+'&sourceOrganization=b2c93b43-c6ff-4ca0-b61d-88b2326bdcc0'; break;
    		case 'referral': url = '/#organization/'+this.model.get('id')+'/patients?'+from+to+'variant=referral&'+this.getMedsideExternalIdsParams()+'&sourceOrganization=b2c93b43-c6ff-4ca0-b61d-88b2326bdcc0'; break;
    		default: alert('Please, select report.');
    	}        
        if(url)window.open(url);
    },
    
    
    
    onRender: function () {
        this.ui.reportType.selectize({        	
        });
        this.ui.dateFrom.datepicker({
            format: 'mm/dd/yyyy',
            autoclose: true,
            clearBtn: true
        });
        this.ui.dateTo.datepicker({
            format: 'mm/dd/yyyy',
            autoclose: true,
            clearBtn: true
        });
    },
    
    changeReportType: function (){
    	//alert(this.ui.reportType.val());
    	switch(this.ui.reportType.val()){
		case 'basic': this.ui.basicTitleDates.attr("hidden", false); this.ui.referralTitleDates.attr("hidden", true); break;
		case 'simple': this.ui.basicTitleDates.attr("hidden", false); this.ui.referralTitleDates.attr("hidden", true); break;
		case 'referral': this.ui.basicTitleDates.attr("hidden", true); this.ui.referralTitleDates.attr("hidden", false); break;
		default: this.ui.basicTitleDates.attr("hidden", true); this.ui.referralTitleDates.attr("hidden", true); break;
	} 
    }

});

module.exports = OrganizationDataView;


//////////////////
// WEBPACK FOOTER
// ./app/views/organizations/organization-data.js
// module id = 232
// module chunks = 0